import { useLocation, Navigate } from "react-router-dom";

// Retire les accents des URL tapées par les joueurs (/trône → /trone)
function NormalizeRoute({ children }) {
    const location = useLocation();

    // Le chemin du navigateur est encodé (/tr%C3%B4ne) : on le décode avant de comparer
    let path = location.pathname;
    try {
        path = decodeURIComponent(path);
    } catch (e) {
        return children; // encodage invalide : la route 404 s'en charge
    }
    const normalizedPath = path.normalize("NFD").replace(/[̀-ͯ]/g, "");

    // Redirige si le chemin n'est pas normalisé
    if (normalizedPath !== path) {
        return <Navigate to={{ ...location, pathname: normalizedPath }} replace />;
    }

    return children;
}

export default NormalizeRoute;
